/**
 * While viewing a regulation detail opened with an omit-domain `source` query
 * (chatbot, assessmentCenter, newsletter, relatedItem), gri-service requests
 * should omit the `domain` header. Cleared on leave so list APIs keep store domain.
 */

let chatbotDetailSkipDomainActive = false;

export function setChatbotDetailSkipDomainForSession(active: boolean): void {
  chatbotDetailSkipDomainActive = active;
}

export function isChatbotDetailSkipDomainActive(): boolean {
  return chatbotDetailSkipDomainActive;
}
